import React, { memo, useEffect } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { useCustomReports } from 'Context/CustomReports';
import { ProjectStatusChart } from './ProjectStatusChart/ProjectStatusChart';
import { RecentTimecards } from './RecentTimecards/RecentTimecards';
import { EquipmentChart } from './EquipmentChart/EquipmentChart';
import { ProjectsOverTime } from './ProjectsOverTime/ProjectsOverTime';
import classes from './customReports.module.css';

function CustomReportsContainer() {
  const {
    fetchProjectsByStatus,
    fetchRecentTimecards,
    fetchEquipmentDeployments,
    fetchProjectsOverTime,
  }: any = useCustomReports();

  useEffect(() => {
    fetchProjectsByStatus();
    fetchRecentTimecards();
    fetchEquipmentDeployments();
    fetchProjectsOverTime();
  }, [fetchProjectsByStatus, fetchRecentTimecards, fetchEquipmentDeployments, fetchProjectsOverTime]);

  return (
    <div className={classes.container}>
      <h4 className={classes.pageTitle}>Reports</h4>
      <div className={classes.grid}>
        <ProjectStatusChart />
        <RecentTimecards />
        <EquipmentChart />
        <ProjectsOverTime />
      </div>
    </div>
  );
}

const CustomReportsContainerMemo = memo(CustomReportsContainer, areEqual);
export { CustomReportsContainerMemo as CustomReportsContainer };
